import { format } from 'libs';
import Number from './Number';
import type { ComponentProps } from 'react';

type CurrencyProps = Omit<ComponentProps<typeof Number>, 'formatter'>;

const Currency = ({ ref, ...props }: CurrencyProps) => <Number {...props} formatter={format.currency} ref={ref} />;

export default Currency;
